// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.lJT3XT {
  display: flex;
  align-items: center;
  gap: var(--spacing-3);
  width: 100%;
  padding: var(--spacing-3);
  background: var(--surface-neutral-white);
  border: none;
  border-radius: var(--radius-s);
  box-shadow: var(--card-box-shadow);
  cursor: pointer;
  text-align: left;
  transition:
    transform 0.2s ease,
    box-shadow 0.2s ease;
}

.lJT3XT:hover {
  transform: translateY(-2px);
  box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.16);
}

.lJT3XT:focus {
  outline: 2px solid var(--surface-primary-medium);
  outline-offset: 2px;
}

.WgNxns {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: var(--surface-primary-medium);
  flex-shrink: 0;
}

.WgNxns img {
  width: 16px;
  height: 16px;
  filter: var(--product-card-icon-filter-contracted);
}

.bqJ33b {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}

.vzP7G1 {
  margin: 0;
  font-family: var(--font-family-base);
  font-size: var(--type-subtitle-md-font-size);
  font-weight: var(--font-weight-semibold);
  color: var(--text-neutral-dark);
}

.W_W42g {
  margin: 0;
  font-family: var(--font-family-base);
  font-size: var(--type-label-sm-font-size);
  color: var(--text-neutral-stronger);
}

.zOlvu1 {
  width: 16px;
  height: 16px;
  flex-shrink: 0;
  filter: var(--product-card-icon-filter);
}
`, "",{"version":3,"sources":["webpack://./src/components/ContabilLinkPendingBanner/ContabilLinkPendingBanner.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;EACX,yBAAyB;EACzB,wCAAwC;EACxC,YAAY;EACZ,8BAA8B;EAC9B,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB;;wBAEsB;AACxB;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,gDAAgD;EAChD,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yCAAyC;EACzC,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kDAAkD;AACpD;;AAEA;EACE,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,SAAS;EACT,oCAAoC;EACpC,4CAA4C;EAC5C,wCAAwC;EACxC,+BAA+B;AACjC;;AAEA;EACE,SAAS;EACT,oCAAoC;EACpC,yCAAyC;EACzC,mCAAmC;AACrC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,uCAAuC;AACzC","sourcesContent":[".banner {\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-3);\n  width: 100%;\n  padding: var(--spacing-3);\n  background: var(--surface-neutral-white);\n  border: none;\n  border-radius: var(--radius-s);\n  box-shadow: var(--card-box-shadow);\n  cursor: pointer;\n  text-align: left;\n  transition:\n    transform 0.2s ease,\n    box-shadow 0.2s ease;\n}\n\n.banner:hover {\n  transform: translateY(-2px);\n  box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.16);\n}\n\n.banner:focus {\n  outline: 2px solid var(--surface-primary-medium);\n  outline-offset: 2px;\n}\n\n.iconContainer {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  background: var(--surface-primary-medium);\n  flex-shrink: 0;\n}\n\n.iconContainer img {\n  width: 16px;\n  height: 16px;\n  filter: var(--product-card-icon-filter-contracted);\n}\n\n.content {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  min-width: 0;\n}\n\n.title {\n  margin: 0;\n  font-family: var(--font-family-base);\n  font-size: var(--type-subtitle-md-font-size);\n  font-weight: var(--font-weight-semibold);\n  color: var(--text-neutral-dark);\n}\n\n.description {\n  margin: 0;\n  font-family: var(--font-family-base);\n  font-size: var(--type-label-sm-font-size);\n  color: var(--text-neutral-stronger);\n}\n\n.chevron {\n  width: 16px;\n  height: 16px;\n  flex-shrink: 0;\n  filter: var(--product-card-icon-filter);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"banner": `lJT3XT`,
	"iconContainer": `WgNxns`,
	"content": `bqJ33b`,
	"title": `vzP7G1`,
	"description": `W_W42g`,
	"chevron": `zOlvu1`
};
module.exports = ___CSS_LOADER_EXPORT___;
